import { useNuxtApp } from 'nuxt/app'

export default () => {
  const { $store } = useNuxtApp()
  const INDEX_PAGE_PATH = '/welcome/'

  return $store.getters?.user?.defaultHomePage || INDEX_PAGE_PATH
}
